export default "__VITE_ASSET__18153c9f__"